import React from 'react';
import { Stack } from '@mui/material';
import EdgeTypeSelector from '../EdgeTypeSelector';
import EdgeActionButtons from '../EdgeActionButtons';
import { DeckBoxEdgeTypes } from '../../context/DeckContext';
import EdgeType from '../../../../../../enums/edgeType';
import { Block, Edge } from '../../../../../../types/shared/blocks';

interface DeckBoxEdgePopperProps {
	block: Block;
	blockEdge: Edge;
	inputEdge: EdgeType | undefined;
	setInputEdge: (edgeType: EdgeType) => void;
	onAddLanding: () => void;
	onAddStair: () => void;
	onDropdownOpenChange?: (open: boolean) => void;
}

const DeckBoxEdgePopper: React.FC<DeckBoxEdgePopperProps> = ({
	blockEdge,
	inputEdge,
	setInputEdge,
	onAddLanding,
	onAddStair,
	onDropdownOpenChange,
}) => {
	const isEdgeDisabled = blockEdge?.type === EdgeType.BLOCK_ATTACHED;

	return (
		<Stack spacing={1.25}>
			<EdgeTypeSelector
				edgeTypes={DeckBoxEdgeTypes}
				value={inputEdge}
				onChange={setInputEdge}
				disabled={isEdgeDisabled}
				label="Edge Types"
				onDropdownOpenChange={onDropdownOpenChange}
			/>

			<EdgeActionButtons
				showAddLanding={true}
				showAddStair={true}
				onAddLanding={onAddLanding}
				onAddStair={onAddStair}
			/>
		</Stack>
	);
};

export default DeckBoxEdgePopper;
